// to be used on all case studies
// scroll label with moving arrow
import React from "react";
import styled from "styled-components";
import { screen, larsseit } from "../common/variables";
import Arrow from "../../images/svg/arrow.svg";
import { motion } from "framer-motion";

const Wrapper = styled.p`
  display: none;

  @media ${screen.small} {
    color: #9d9d9d;
    position: absolute;
    right: 35px;
    font-size: 1.1rem;
    display: flex;
    font-family: ${larsseit};
    align-items: center;
    transform: rotate(90deg);
    top: 540px;
    font-weight: 300;
    z-index: 10;
  }
  @media ${screen.medium} {
    right: calc(7vw - 46px);
    font-size: 1.15rem;
    top: 550px;
  }

  .arrow {
    width: 35px;
    margin: 4px 0 0 10px;
  }
`;

const ScrollHint = () => {
  return (
    <Wrapper>
      <span>SCROLL</span>
      <motion.span
        animate={{ x: 6 }}
        transition={{
          yoyo: Infinity,
          type: "spring",
          mass: 1.6,
          stiffness: 110,
        }}
        className="arrow"
      >
        <Arrow />
      </motion.span>
    </Wrapper>
  );
};

export default ScrollHint;
